const context = require("react").useContext;
module.exports = class Driver {
  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      url: "https://core.pajoohyar.ir"
    };
    let globalheaders = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      "Content-Type": "application/json",
      Accept: "application/json"
    };
    this.on_auth_error = () => {
      this.access_token = null;
      this.expires_at = null;
      setTimeout(() => {
        console.log("redirect!");
      }, 500);
    };
    this.config = config;
    this.context = context;
    this.globalheaders = globalheaders;
    this.access_token = null;
    this.expires_at = null;
    require("pajoohyar-api-driver/blog").init(this);
    require("pajoohyar-api-driver/log").init(this);
    require("pajoohyar-api-driver/csl").init(this);
    require("pajoohyar-api-driver/metadata").init(this);
    require("pajoohyar-api-driver/utils").init(this);
    require("pajoohyar-api-driver/workshop").init(this);
    require("pajoohyar-api-driver/translators").init(this);
    require("pajoohyar-api-driver/help").init(this);
    require("pajoohyar-api-driver/teachers").init(this);
    require("pajoohyar-api-driver/auth").init(this);
    require("pajoohyar-api-driver/onlinelibrary").init(this);
    require("pajoohyar-api-driver/schemas").init(this);
  }
};